import { render } from "./report_item.vue?vue&type=template&id=6e64f03c&scoped=true"
import script from "./report_item.vue?vue&type=script&lang=js"
export * from "./report_item.vue?vue&type=script&lang=js"

import "./report_item.vue?vue&type=style&index=0&id=6e64f03c&scoped=true&lang=css"

import exportComponent from "E:\\devops.aliyun\\deyi\\baobei_web2\\web2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e64f03c"]])

export default __exports__